import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// PWA Service Worker — replaces the old kill-switch. If the browser
// supports SW, we register our own; otherwise we no-op.
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js", { scope: "/" }).catch(() => { /* ignore */ });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);

// Performance: auto-apply native image lazy-loading + async decoding to every
// `<img>` that doesn't already opt in. Below-the-fold images then don't block
// the main thread or steal bandwidth from critical resources.
(function autoLazyLoadImages() {
  if (typeof window === 'undefined') return;
  const apply = (img) => {
    try {
      if (!img.hasAttribute('loading')) img.setAttribute('loading', 'lazy');
      if (!img.hasAttribute('decoding')) img.setAttribute('decoding', 'async');
    } catch { /* ignore */ }
  };
  const observer = new MutationObserver((mutations) => {
    for (const m of mutations) {
      for (const n of m.addedNodes) {
        if (n.nodeType !== 1) continue;
        if (n.tagName === 'IMG') apply(n);
        else if (n.querySelectorAll) n.querySelectorAll('img').forEach(apply);
      }
    }
  });
  const start = () => {
    document.querySelectorAll('img').forEach(apply);
    observer.observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else { start(); }
})();
